import { EventEmitter } from 'events'

window.Carwow = window.Carwow || {}
window.Carwow.eventBus = window.Carwow.eventBus || new EventEmitter()
export default window.Carwow.eventBus
